import { createSlice } from '@reduxjs/toolkit';

export const errorSlice = createSlice({
  name: 'error',
  initialState: {
    code: ""
  },
  reducers: {
    setError: (state, action) =>
    {
      state.code = action.payload;
    }
  }
});

export const { setError } = errorSlice.actions;

export const getError = state => state.error;



export default errorSlice.reducer;
